import { createReducer, on, Action } from '@ngrx/store';
import { Details } from '@details/Interfaces/details';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as CreditorDetailsActions from '../actions/creditor-details.actions';
import { Field } from '@common/models/field-definition';

export class CreditorDetailsInstance {
  id: number;
  details?: Details;
  fields?: Field[];
  loading: boolean;
}

export const adapter: EntityAdapter<CreditorDetailsInstance> = createEntityAdapter<CreditorDetailsInstance>();

export interface CreditorDetailsState extends EntityState<CreditorDetailsInstance> { }

export const initialState: CreditorDetailsState = adapter.getInitialState();

const creditorDetailsReducer = createReducer(
  initialState,
  on(CreditorDetailsActions.loadDetails, (state, { widgetId }) => {
    const instance: CreditorDetailsInstance = { id: widgetId, loading: true, details: undefined };
    return adapter.upsertOne(instance, state);
  }),
  on(CreditorDetailsActions.loadDetailsComplete, (state, { details, widgetId }) => {
    const instance: CreditorDetailsInstance = { id: widgetId, loading: false, details };
    return adapter.upsertOne(instance, state);
  })
);

export function reducer(state: CreditorDetailsState | undefined, action: Action) {
  return creditorDetailsReducer(state, action);
}
